import { afterNextRender, Component, DestroyRef, inject, signal } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DashboardService } from '../../_services/dashboard/dashboard.service';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-about-us',
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);
  readonly showHeroVideo = signal(false);


  logos: string[] = [
    'assets/img/logos/peak-xv-partners.png',
    'assets/img/logos/itc-limited.png',
    'assets/img/logos/ub.png',
    'assets/img/logos/lightspeed.png',
    'assets/img/logos/ola.png',
    'assets/img/logos/bb.png',
    'assets/img/logos/linde.png',
    'assets/img/logos/infosys.png',
    'assets/img/logos/nvidia.png',
    'assets/img/logos/wipro.png',
    'assets/img/logos/bcg.png',
    'assets/img/logos/kearney.png'
  ];

  readonly audiences = ['CXOs', 'Unicorn Founders', 'Family Offices', 'HNIs', 'Entrepreneurs'];
  readonly companyNames = ['Peak XV Partners', 'ITC Limited', 'Uber', 'Lightspeed', 'Ola', 'BigBasket', 'Linde', 'Infosys', 'NVIDIA', 'Wipro', 'BCG', 'Kearney'];

  email_subscribe: string = '';
  subscribeSuccess: boolean = false;
  subscribeError: boolean = false;

  constructor(
    private _DS: DashboardService,
  ){
    afterNextRender(() => {
      const desktop = this.document.defaultView?.matchMedia('(min-width: 768px)');
      if (!desktop) return;
      const updateMedia = () => this.showHeroVideo.set(desktop.matches);
      updateMedia();
      desktop.addEventListener('change', updateMedia);
      this.destroyRef.onDestroy(() => desktop.removeEventListener('change', updateMedia));
    });
  }
  subscribe(form: any) {
  if (form.invalid) {
    this.subscribeSuccess = false;
    this.subscribeError = false;
    return;
  }
  this.subscribeSuccess = false;
  this.subscribeError = false;

  this._DS.addSubscriber(this.email_subscribe).subscribe({
      next: () => {
        this.subscribeSuccess = true;
        this.email_subscribe = '';
        form.resetForm();
      },
      error: (err) => {
        this.subscribeError = true;
      }
    });
  }

}
